/**
 * Status display. Receiver voice only — terse, factual, no apology, no software
 * vocabulary, never instructing (ENG-060, Voice Guide section 3).
 */
import type { Ctx, V1State } from '../core/machine';
import { RECEIVER_COPY } from '../core/constants';

const LINE: Record<V1State, (c: Ctx) => string> = {
  BOOTING: () => '',
  STARTUP: () => '',
  ARRIVED: () => RECEIVER_COPY.noSignal,
  IDLE_PROMPT: () => RECEIVER_COPY.noSignal,
  ACCEPTING: (c) => `${c.broadcastName}  ${RECEIVER_COPY.acquiring}`,
  WAKING: (c) => `${c.broadcastName}  ${RECEIVER_COPY.acquiring}`,
  LOCKING: (c) => `${c.broadcastName}  ${RECEIVER_COPY.acquiring}`,
  REALM: (c) => c.broadcastName,
  FAILED: () => RECEIVER_COPY.signalLost,
};

export function mountStatusDisplay(parent: HTMLElement): (c: Ctx) => void {
  const el = document.createElement('div');
  el.className = 'cc-status';
  el.setAttribute('role', 'status');
  el.setAttribute('aria-live', 'polite');
  parent.append(el);

  const sub = document.createElement('div');
  sub.className = 'cc-status-sub';
  parent.append(sub);

  return (c: Ctx): void => {
    el.textContent = LINE[c.state](c);
    // Failure names what was sought, using the cached display name (ENG-029, ENG-052).
    sub.textContent = c.state === 'FAILED' && c.failure ? c.failure : '';
  };
}
